import React from "react";
import {CImg} from "@coreui/react";

const ARLogo = (props) => (
  <CImg
    src="/logo/logo_2.png"
    alt="ARLogo"
    {...props}
  />
);

ARLogo.defaultProps = {
  width: 60,
  height: 60,
  placeholderColor: "lightgrey"
};

export default ARLogo;